import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateApipayOrderStatus = {
  apipayOrderStatus: { data: null, loading: false, error: null },
};

export const apipayOrderStatus = createAsyncThunk(
  "payment/apipayOrderStatus",
  async (orderId, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(
        `${process.env.REACT_APP_SERVER_API}/payments/apipay/orders/${orderId}/status/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(
          res.response?.data || { error: "Ошибка при проверке статуса" }
        )
      );
  }
);

export const reducerApipayOrderStatus = {
  [apipayOrderStatus.pending]: (state) => {
    state.apipayOrderStatus.loading = true;
    state.apipayOrderStatus.error = null;
  },
  [apipayOrderStatus.fulfilled]: (state, action) => {
    state.apipayOrderStatus.loading = false;
    state.apipayOrderStatus.data = action.payload;
    state.apipayOrderStatus.error = null;
  },
  [apipayOrderStatus.rejected]: (state, action) => {
    state.apipayOrderStatus.loading = false;
    state.apipayOrderStatus.error = action.payload;
  },
};

